import React, { useEffect, useRef } from 'react';
import HeroImage from '../assets/heroImage.jpg';
import { MdKeyboardArrowRight } from 'react-icons/md';
import gsap from 'gsap';
import { Link } from 'react-scroll';
import { useTranslation } from 'react-i18next';

const Home = () => {
	const ref = useRef();
	const avatrRef = useRef();
	const { t } = useTranslation('translation', {
		keyPrefix: 'home',
	});

	useEffect(() => {
		let ctx = gsap.context(() => {
			gsap.fromTo(
				ref.current,
				{
					opacity: 0,
					y: -50,
				},
				{
					opacity: 1,
					y: 0,
					duration: 1,
				}
			);
			gsap.fromTo(
				avatrRef.current,
				{
					opacity: 0,
					x: 200,
				},
				{
					opacity: 1,
					x: 0,
					duration: 1,
				}
			);
		});

		return () => ctx.revert();
	}, []);

	return (
		<section
			name='home'
			className='h-screen w-full bg-gradient-to-b from-black via-black to-gray-800'
		>
			<div
				className='max-w-screen-lg mx-auto flex flex-col items-center 
				justify-center h-full px-4 md:flex-row '
			>
				<div ref={ref} className='flex flex-col justify-center h-full'>
					<h2 className='text-4xl sm:text-7xl font-bold text-white'>
						{t('title')}
					</h2>
					<p className='text-gray-500 py-4 max-w-md'>{t('subTitle')}</p>

					<div>
						<button
							className='group text-white w-fit px-6 py-3 my-2 flex items-center 
						rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer'
						>
							<Link to={'portfolio'} smooth duration={500}>
								Porfolio
							</Link>

							<span className='group-hover:rotate-90 duration-300'>
								<MdKeyboardArrowRight size={25} className='ml-1' />
							</span>
						</button>
					</div>
				</div>
				<div ref={avatrRef}>
					<img
						src={HeroImage}
						alt='avatar'
						className='rounded-2xl mx-auto w-2/3 md:w-full'
					/>
				</div>
			</div>
		</section>
	);
};

export default Home;
